export default __webpack_public_path__ + "static/media/528hz-dna-repair.3d7e489c.jpg";